module.exports = __webpack_public_path__ + "static/media/undying_fury.63766474.png";